@if (brandForm()) {
<form [formGroup]="brandForm()">
    <div class="row mb-3">
        <div class="col-md-4">
            <div class="form-group">
                <label>Código</label>
                <div class="form-group">
                    <strong>{{ brandForm().get('code')?.value || '—' }}</strong>
                    @if (mode() == formMode.CREATE) {
                    <div class="text-muted small">Se genera automáticamente</div>
                    }
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="form-group">
                <label>Nombre</label>
                @if (mode() == formMode.CREATE || mode() == formMode.EDIT) {
                <input type="text" class="form-control" formControlName="name">
                } @else {
                <div class="form-group">
                    <strong>{{ brandForm().get('name')?.value }}</strong>
                </div>
                }
            </div>
        </div>
    </div>
    @if (mode() == formMode.VIEW) {
    <div class="row">
        <div class="col-12 d-flex justify-content-end gap-2">
            @if (perm.canCurrent('canUpdate')) {
            <button class="btn btn-outline-primary btn-sm" (click)="editMode()">
                <i class="fas fa-edit"></i> Editar
            </button>
            }
            @if (perm.canCurrent('canDelete')) {
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteBrand()">
                <i class="fas fa-trash-alt"></i> Eliminar
            </button>
            }
        </div>
    </div>
    }
</form>
<ng-content></ng-content>
}
